export default __webpack_public_path__ + "static/media/640_dummy2016-fashion01-mobile-de.eb1f7ad7.png";